import React from "react";
import "../styles/welcomeHeader.css";

interface IHeader {
  title: string;
  logo: string;
}

const WelcomeHeader: React.FC<IHeader> = ({ title, logo }: IHeader) => {
  return (
    <div className="welcomeHeader" data-testid="welcomeContainer">
      <img width="112" height="112" src={logo} alt={title} data-testid="logo" />
    </div>
  );
};

export default WelcomeHeader;
